(function($) {
	$(document).ready(function(){
		if ($.fn.slick) {
			$('.design-process-slider').slick({
				infinite: false,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				responsive: [
					{
						breakpoint: 1251,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
					}
				]
			});
		}

		var boxTallest = 0;
		var totalBox = $('.method-box').length;
		$( ".method-box" ).each(function( index ) {
			if ($(this).height() > boxTallest) {
				boxTallest = $(this).height();
			}
		  	if (index === totalBox - 1) {
		        $( ".method-box .wp-block-group__inner-container" ).css('min-height', boxTallest);
		    }
		});
	});
})(jQuery);
